module.exports = __webpack_public_path__ + "img/3.cbd6b068.png";